import {Card, Col, Row} from "antd";
import {useEffect, useState} from "react";
import {apiError, handleRequest} from "../../../utils";
import {ticketApi} from "../../../api";
import DOMPurify from "dompurify";
import TicketFormComment from "./Form/TicketFormComment";


function TicketComment({ticket})
{
    const [comments, setComments] = useState([])

    const eventsHandler = {
        load: async () => {

            let [error, response] = await handleRequest(ticketApi.comment({
                id: ticket.id
            }));

            let message = apiError(`Load câu trả lời cho ticket thất bại`, error, response);

            if (!message)
            {
                setComments(response.data);
            }
        },
    }

    function CommentTitle({comment}) {
        return <>
            <p>{comment.userName}</p>
            <p style={{fontSize:'13px', fontWeight:'normal'}}>{comment.created}</p>
        </>
    }

    useEffect(() => {
        eventsHandler.load().then()
    }, [ticket])

    return (
        <>
            {
                comments.length > 0 && comments.map((comment, index) => {
                    const color = comment.userIdType === 'customer' ? '#f50' : '#12356c';
                    return <Card title={<CommentTitle comment={comment} />} headStyle={{ backgroundColor: color, color: '#ffffff' }} className={'mt-1'} bodyPadding={1}>
                        <div style={{wordBreak : 'break-all'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(comment.message) }} />
                        {comment.files && <><hr /><p className={'mb-1 mt-1'}><b>File Đính kèm</b></p></>}
                        {comment.files && comment.files.map((f, index) => (<p><a href={f.filePath} download>{f.filePath}</a></p>))}
                    </Card>
                })
            }
            <Row gutter={16}>
                <Col span={12}>
                    <TicketFormComment ticket={ticket} setComments={setComments} comments={comments} />
                </Col>
                <Col span={12}>
                    <h4 className={'mt-3'}>Mẫu phản hồi</h4>
                    <p className={'mb-1 mt-2'}>Kính thưa Quý khách,</p>
                    <p className={'mb-1'}>Chăm Sóc Khách Hàng Sikido đã tiếp nhận yêu cầu <b>#TK{ticket.id} - {ticket.title}</b> của Quý khách.</p>
                    <p className={'mb-1'}>Hiện tại, yêu cầu đang được Sikido tiến hành kiểm tra thông tin để xử lý.</p>
                    <p className={'mb-1'}>Xin trân trọng cảm ơn Quý khách.</p>
                </Col>
            </Row>
        </>

    )
}

export default TicketComment;